<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="最小接单量" prop="receiveMin">
        <el-input type="number"  v-model="form.receiveMin" placeholder="请输入最小接单量" v-trim/>
      </el-form-item>
      <el-form-item label="最大接单量" prop="receiveMax">
        <el-input type="number"  v-model="form.receiveMax" placeholder="请输入最大接单量" v-trim/>
      </el-form-item>
      <el-form-item label="优先级" prop="level">
        <el-input type="number" v-model="form.level" placeholder="请输入优先级" v-trim/>
      </el-form-item>
      <el-form-item label="订单查看延迟时间（分钟）" prop="delayTime">
        <el-input type="number" v-model="form.delayTime" placeholder="请输入订单查看延迟时间" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input  type="textarea"  v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaReceiveWeightWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        deleted: '',
        status: '',
        createUser: '',
        createTime: '',
        updateUser: '',
        updateTime: '',
        remark: '',
        receiveMax: '',
        receiveMin: '',
        level: '',
        delayTime: '',
        sortnum: ''
      },
      // 验证规则
      rules: {
        receiveMin: [{ required: true, message: '请输入最小接单量' }],
        receiveMax: [{ required: true, message: '请输入最大接单量' }],
        level: [{ required: true, message: '请输入优先级' }],
        delayTime: [{ required: true, message: '订单查看延迟时间' }],
      }
    }
  },
  created () {
    this.config({
      api: '/business/receiveWeight',
      'field.id': 'id'
    })
  }
}
</script>
